var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-form",
    { attrs: { model: _vm.form } },
    [
      _c(
        "a-form-item",
        [
          _c("h1", [_vm._v("12222222")]),
          _c("a-ext-pin-zhong-and-bad-select", {
            model: {
              value: _vm.form.val,
              callback: function ($$v) {
                _vm.$set(_vm.form, "val", $$v)
              },
              expression: "form.val",
            },
          }),
        ],
        1
      ),
      _c(
        "a-form-item",
        [
          _c(
            "a-button",
            { attrs: { type: "primary" }, on: { click: _vm.test } },
            [_vm._v("查询")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }